var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrapper"},[_c('h3',{staticClass:"title"},[_vm._t("default")],2),_c('div',{staticClass:"title-extra"},[_vm._t("extra")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }